import { createFileRoute } from '@tanstack/react-router';

import { filterState, getSupportTicketsAllQueryOptions } from '@/_containers';
import Loading from '@/_pages/support/main/loading';

export const Route = createFileRoute('/_private/support/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true, isViewOnly: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getSupportTicketsAllQueryOptions()),
  pendingComponent: Loading,
});
